<nz-table #notificationHistoryTable [nzData]="notificationHistory" [nzFrontPagination]="false">
    <thead>
        <tr>
            <th></th>
            <th>Nosūtītājs</th>
            <th>Saņēmēja veids</th>
            <th>Temats</th>
            <th>Nosūtīts</th>
        </tr>
    </thead>
    <tbody>
        @for (notificationHistory of notificationHistoryTable.data; track notificationHistory) {
            <tr>
                <td [nzExpand]="expandSet.has(notificationHistory.id)" (nzExpandChange)="onExpandChange(notificationHistory.id, $event)"></td>
                <td>{{ notificationHistory.senderUser?.name + ' ' + notificationHistory.senderUser?.surname }}</td>
                <td>{{ notificationHistory.notificationReceiverType.description }}</td>
                <td>{{ notificationHistory.subject }}</td>
                <td>{{ notificationHistory.firstSaveTime | date: DATE_TIME_FORMAT }}</td>
            </tr>
            <tr [nzExpand]="expandSet.has(notificationHistory.id)">
                <cl-notification-history-entry-details [notificationHistory]="notificationHistory"></cl-notification-history-entry-details>
            </tr>
        }
    </tbody>
</nz-table>
<div *nzModalFooter></div>
